import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  useDisclosure,
  IconButton,
} from "@chakra-ui/react";
import { useState } from "react";
import { AgeGroup } from "./ResultDownloadView";
import { Gender } from "../../../Api/dto/Discipline_POST_PUT";
import { PlusIcon } from "lucide-react";

export default function NewAgeGroupModal(props: {onCreate: (maxAge: number, gender: Gender) => void}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [maxAlder, setMaxAlder] = useState<number | undefined>(undefined);
  const [kon, setKon] = useState<Gender | undefined>(undefined);

  const handleSubmit = () => {
    if (maxAlder !== undefined && kon !== undefined) {
        setMaxAlder(undefined);
        setKon(undefined);
        props.onCreate(maxAlder, kon);
    }
    onClose();
  };

  return (
    <>
     <IconButton onClick={onOpen} icon={<PlusIcon/>} aria-label="Lägg till åldersgrupp" variant={"ghost"}/>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Skapa ny åldersgrupp</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Maxålder (år)</FormLabel>
              <Input
                type="number"
                value={maxAlder}
                onChange={(e) => setMaxAlder(parseInt(e.target.value))}
                placeholder="t.ex. 18"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Kön</FormLabel>
              <Select
                placeholder="Välj kön"
                value={kon}
                onChange={(e) => setKon(e.target.value as Gender)}
              >
                <option value={Gender.WOMAN}>Kvinna</option>
                <option value={Gender.MAN}>Man</option>
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Avbryt
            </Button>
            <Button colorScheme="blue" onClick={() => {
                if (kon != null && maxAlder != null) {
                    handleSubmit();
                }
            }}>
              OK
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}